const LOG_LEVEL = {
      DEBUG: 0,
      INFO: 1,
      WARN: 2,
      ERROR: 3,
      NONE: 4
};

// Force DEBUG level during development
const CURRENT_ENV = process.env.NODE_ENV || 'development';
const DEFAULT_LEVEL = CURRENT_ENV === 'production' ? LOG_LEVEL.ERROR : LOG_LEVEL.DEBUG;

class Logger {
      static level = LOG_LEVEL.DEBUG; // Force DEBUG level for now

      static debug(message, ...args) {
            if (this.level <= LOG_LEVEL.DEBUG) {
                  console.log('🔍 [DEBUG]', message, ...args); // Changed to more visible console.log
            }
      }

      static info(message, ...args) {
            if (this.level <= LOG_LEVEL.INFO) {
                  console.log('ℹ️ [INFO]', message, ...args); // Added emoji for visibility
            }
      }

      static warn(message, ...args) {
            if (this.level <= LOG_LEVEL.WARN) {
                 // console.warn('⚠️ [WARN]', message, ...args);
            }
      }

      static error(message, error, ...args) {
            if (this.level <= LOG_LEVEL.ERROR) {
                  console.error('❌ [ERROR]', message, error, ...args);
            }
      }

      static api(method, url, data) {
            if (this.level <= LOG_LEVEL.DEBUG) {
                  //console.group('🌐 [API]', `${method} ${url}`);
                  //if (data) console.log('📦 Data:', data);
                  //console.groupEnd();
            }
      }

      static component(name, action, data) {
            if (this.level <= LOG_LEVEL.DEBUG) {
                  //console.group('🔷 [COMPONENT]', `${name} - ${action}`);
                  //if (data) console.log('📦 Data:', data);
                  //console.groupEnd();
            }
      }

      static state(component, action, prevState, nextState) {
            if (this.level <= LOG_LEVEL.DEBUG) {
                  //console.group('📊 [STATE]', `${component} - ${action}`);
                  //console.log('⬅️ Previous:', prevState);
                  //console.log('➡️ Next:', nextState);
                  //console.groupEnd();
            }
      }

      // Test method to verify logger is working
      static test() {
            this.debug('Debug message test');
            this.info('Info message test');
            this.warn('Warning message test');
            this.error('Error message test');
            this.api('GET', '/test', { data: 'test' });
            this.component('TestComponent', 'mount', { prop: 'test' });
            this.state('TestComponent', 'update', { old: 'data' }, { new: 'data' });
      }
}

// Run test on import during development
if (process.env.NODE_ENV !== 'production') {
     // Logger.test();
}

export default Logger; 